import { axiosBaseQuery } from "@api/base-services-axios-rtx";
import { createApi } from "@reduxjs/toolkit/query/react";

import { IUpdateUserFormPayload } from "@/private/modules/user/components/create-edit-form/util/model/user-form-payload.interface";
import { createQuery } from "@/shared/helpers/create-query.helper";
import getFormData from "@/shared/helpers/get-form-data.helper";
import { UsersEndpoints } from "@/shared/models/endpoints/users.endpoint";
import { IUserDetailResponse } from "@/shared/models/interfaces/response/users/user-detail-response.interface";
import { UserListResponse } from "@/shared/models/interfaces/response/users/user-list-response.interface";
import { BaseValueModelQRTK } from "../../model/base-values.interface";
import { UserListValuesQRTK } from "./values/user-list.values";
import { IUserExceptionsResponse } from "@/shared/models/interfaces/response/users/user-exceptions-response.interface";
import { IUserResponse } from "@/src-refactor/modules/store/qrtk/services/users/responses/get-user.response";
import HGetFormData from "@rf-helper/create-form-data.helper";
import {
  remaxGlobalDetailMock,
  remaxGlobalListMock
} from "@rf/mock/remax_global.mock";

export const UsersQueryServices = createApi({
  reducerPath: "Users-services",
  baseQuery: axiosBaseQuery(),

  endpoints: builder => ({
    createUser: builder.mutation({
      query: (values: BaseValueModelQRTK<any>) => ({
        url: UsersEndpoints.UserCreate,
        method: "POST",
        body: HGetFormData(values.body)
      }),
      transformResponse: (response: any, meta, arg) => response.data
    }),
    updateUser: builder.mutation({
      query: (values: { id: number; body: IUpdateUserFormPayload }) => ({
        url: UsersEndpoints.UserUpdate(values.id),
        method: "POST",
        body: HGetFormData(values.body)
      }),
      transformResponse: (response: any, meta, arg) => response.data
    }),
    getUser: builder.mutation({
      query: (values: { id: number }) => ({
        url: UsersEndpoints.UserDetail(values.id),
        method: "GET"
      }),
      transformResponse: (response: any, meta, arg) =>
        remaxGlobalDetailMock(response.data)
    }),
    getListUser: builder.mutation({
      query: (values: UserListValuesQRTK) => {
        return {
          url: UsersEndpoints.UsersList + createQuery(values.query),
          method: "GET"
        };
      },
      transformResponse: (response: UserListResponse, meta, arg) => {
        return {
          ...response,
          data: remaxGlobalListMock(response.data)
        };
      }
    }),

    activateUser: builder.mutation({
      query: (values: { id: number }) => ({
        url: UsersEndpoints.ActivateUser(values.id),
        method: "PATCH"
      }),
      transformResponse: (response: any, meta, arg) => response
    }),
    suspendUser: builder.mutation({
      query: (values: { id: number; body: any }) => ({
        url: UsersEndpoints.SuspendUser(values.id),
        method: "PATCH",
        body: JSON.stringify(values.body),
        content_type: "application/json"
      }),
      transformResponse: (response: any, meta, arg) => response
    }),
    inactiveUser: builder.mutation({
      query: (values: { id: number }) => ({
        url: UsersEndpoints.InactiveUser(values.id),
        method: "PUT"
      }),
      transformResponse: (response: any, meta, arg) => {
        return { message: " Usuario inactivado correctamente." };
      }
    }),

    resendEmail: builder.mutation({
      query: (values: { id: number }) => ({
        url: UsersEndpoints.resendEmailUser(values.id),
        method: "post"
      }),
      transformResponse: (response: any, meta, arg) => {
        return response;
      }
    }),

    userExceptions: builder.mutation({
      query: (values: any) => ({
        url: UsersEndpoints.UserExceptions,
        method: "GET"
      }),
      transformResponse: (response: IUserExceptionsResponse, meta, arg) => {
        return response;
      }
    })
  })
});

export const {
  useCreateUserMutation,
  useUpdateUserMutation,
  useGetUserMutation,
  useGetListUserMutation,
  useActivateUserMutation,
  useInactiveUserMutation,
  useSuspendUserMutation,
  useResendEmailMutation,
  useUserExceptionsMutation
} = UsersQueryServices;

export interface FiltersListUser {
  q?: string;
  type?: string;
  status?: string;
  agency?: string;
  page: number;
}
